module.exports = __webpack_public_path__ + "static/media/poorly-controlled-asthma-scale-background-adult.d813312c.svg";